<p-sidebar
  [(visible)]="visibleSidebar"
  position="right"
  styleClass="w-screen lg:w-4"
  [modal]="true"
  (onHide)="hide()"
>
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-3">
      <i
        class="pi text-xl cursor-pointer"
        style="padding-top: 1px"
        (click)="hide()"
      ></i>
      <span class="font-bold text-lg">Seleccione un banco</span>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="p-mb-4">
      <div
        *ngFor="let item of listaBancos; let i = index"
        class="p-card border-round border-1 surface-border w-full cursor-pointer flex align-items-center justify-content-between md:min-h-6rem"
        (click)="Selecciona_Banco(item, i)"
        [ngClass]="{
          'p-highlight': index_banco === i,
          'surface-border hover:border-400': index_banco !== i,
          'border-primary bg-blue-50': selectedBankId === item.bankId
        }"
      >
        <div class="p-card-body flex justify-between align-items-center">
          <div class="flex align-items-center p-3" style="padding: 20px">
            <p-radioButton
              name="id"
              [value]="item.bankId"
              [(ngModel)]="selectedBankId"
              styleClass="mr-3"
            ></p-radioButton>
            <div>
              <div
                class="font-semibold mb-1 uppercase"
                style="text-transform: uppercase"
              >
                {{ item.name }}
              </div>
              <div class="text-sm" style="text-transform: uppercase">
                Monto mínimo
                {{ item.minAmount | currency }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <p-button
      label="Ir a pagar"
      [disabled]="!selectedBankId"
      (onClick)="Pagar()"
      styleClass="w-full"
      class="w-full p-button-primary"
    ></p-button>
  </ng-template>
</p-sidebar>

<!-- Start::toast de error o éxito -->
<p-toast />
<!-- End::toast de error o éxito -->
